import MasterCrudPage from "../../components/MasterCrudPage";
import { kycMasterApi } from "../../api/masterApi";

export default function KycMaster() {
  return (
    <MasterCrudPage
      title="KYC Master"
      description="KYC document types such as AADHAR Card, Driving License, PAN Card, Passport."
      idKey="kyc_id"
      api={kycMasterApi}
      listLabel="KYC types"
      useJson
      fields={[
        {
          name: "kyc_field",
          label: "KYC Field",
          type: "text",
          required: true,
          fullWidth: true,
          placeholder: "e.g. AADHAR Card, Driving License, PAN Card, Passport",
        },
      ]}
      columns={[
        { key: "kyc_id", label: "KYC" },
        { key: "kyc_field", label: "KYC Field" },
      ]}
    />
  );
}
